import gql from "graphql-tag";
import {useMutation} from "@apollo/react-hooks";
import {NotifyPaxResponse} from "../../../../../__generated__/graphql/types";
import {Moment} from "moment-timezone";

const SEND_CHECK_IN_NOTIFICATION = gql`
    mutation CheckinPaxNotifierSendNotification(
        $paxIds: [ID!]!
        $requestedCheckInTime: AWSTime!
    ) {
        NotifyPaxCheckIn(paxIds: $paxIds, requestedCheckInTime: $requestedCheckInTime ) {
            results {
                paxId
                success
                errorMessage
            }
            failedCount
            successfulCount
            totalCount
        }
    }
`

export function useSendCheckInNotificationMutation(){
    const [ invoke, result ] = useMutation(SEND_CHECK_IN_NOTIFICATION);

    return {
        sendCheckInNotification: async (paxIds: string[], requestedCheckInTime: Moment) => {
            const result = await invoke({
                variables: {
                    paxIds,
                    requestedCheckInTime: requestedCheckInTime.format('HH:mm:00')
                }
            });

            return {
                ...result,
                data: result.data?.NotifyPaxCheckIn as NotifyPaxResponse | undefined,
                rawData: result.data
            } as SendCheckInNotificationMutationResult
        },
        result: {
            ...result,
            data: result.data?.NotifyPaxCheckIn as NotifyPaxResponse | undefined,
            rawData: result.data
        }
    }
}

export type SendCheckInNotificationMutationResult = ReturnType<typeof useSendCheckInNotificationMutation>['result'];